import React from 'react';
import styles from 'feature/license-plates/index.module.scss';
import iconAlert from 'assets/icon_fill_alert.svg';
import iconLoading from 'assets/icon_fill_clock.svg';
import iconSuccess from 'assets/icon_fill_success.svg';
import { isCpcpay } from 'config';
import { isNpcpay } from 'config';
import { ENERGY_SOURCE } from "model/energy-source";

export const vehicleCarTypes = {
  car: '汽車',
  moto: '機車',
  trailer: '拖車',
  heavy_moto: '大型重型機車',
};

const LicensePlateItem = ({ licensePlate, onClick, withoutEditButton }) => {
  const BindingState = () => {
    const ParkingState = () => {
      const parkingBindingState = licensePlate.cityParkinglots.taipeiCity.state;

      switch (parkingBindingState) {
        case 'processing':
          return (
            <span>
              <img src={iconLoading} alt="loading" />
              停車綁定中
            </span>
          );
        case 'binding_failed':
          return (
            <span>
              <img src={iconAlert} alt="alert" />
              停車綁定失敗
            </span>
          );
        default:
          return (
            <span>
              <img src={iconSuccess} alt="success" />
              停車
            </span>
          );
      }
    };

    const RefuelingState = () => {
      if (isCpcpay || isNpcpay) return '';
      const mochiPassText = licensePlate.mochipassEnable ? '（已開啟快速通）' : '';

      return (
        <span>
          <img src={iconSuccess} alt="success" />
          加油{mochiPassText}
        </span>
      );
    };

    return (
      <div className={styles.state}>
        <RefuelingState />
        <ParkingState />
      </div>
    );
  };

  const energySourceText = licensePlate.energySource ? `/ ${ENERGY_SOURCE[licensePlate.energySource].value}` : ''

  return (
    <div className={styles['license-plates-item']} onClick={onClick}>
      <div className={styles.card}>
        <div className={styles.contnet}>
          <div>
            {licensePlate.plateNumber} / {vehicleCarTypes[licensePlate.vehicleType]} {energySourceText}
          </div>
          <BindingState />
          {licensePlate.isRentalCar && <span className={styles['rental-hint']}>※租約到期請記得解除車牌綁定</span>}
        </div>
        {!withoutEditButton && <div className={styles.button}>編輯</div>}
      </div>
    </div>
  );
};

export default LicensePlateItem;
